export const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999,
    animation: "overlayFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1)",
    pointerEvents: "all",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  modal: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "700px",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    boxShadow: "4px 0px 4px 0px #00000040",
    border: "none",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
    zIndex: 1000,
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    textAlign: "left",
    fontFamily: "inherit",
  },

  content: {
    margin: "22px",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden",
    minHeight: 0,
    boxSizing: "border-box",
    textAlign: "left",
  },

  topSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "10px",
    paddingBottom: "15px",
    borderBottom: "none",
    backgroundColor: "#ffffff",
    margin: 0,
    boxSizing: "border-box",
    textAlign: "left",
  },

  topLeft: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flex: "1 1 0",
    minWidth: 0,
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  // The main notice header is two stacked rows: the logo alone on row 1,
  // aligned per active_config.logo_position, then the title and the
  // TTS/language controls on row 2. `topSection` and `topLeft` above keep their
  // single-row shape for the age-verification, guardian and verification
  // screens, which have no controls to place and share those styles.
  // Mirrors consent-sdk-react/src/RedactoNoticeConsent/styles.ts.
  headerStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "10px",
    paddingBottom: "15px",
    borderBottom: "none",
    backgroundColor: "#ffffff",
    margin: 0,
    boxSizing: "border-box",
    textAlign: "left",
  },

  logoRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    width: "100%",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  logo: {
    height: "32px",
    width: "auto",
    maxWidth: "140px",
    objectFit: "contain",
    flexShrink: 0,
    margin: 0,
    padding: 0,
    display: "block",
  },

  title: {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "150%",
    letterSpacing: "0.2px",
    verticalAlign: "middle",
    color: "#101828",
    flex: "1 1 auto",
    minWidth: 0,
    wordBreak: "normal",
    overflowWrap: "anywhere",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  topRight: {
    borderRadius: "8px",
    padding: "3px 9px",
    border: "1px solid #d0d5dd",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    verticalAlign: "middle",
    color: "#344054",
    gap: "5px",
    margin: 0,
    boxSizing: "border-box",
    textAlign: "left",
    cursor: "pointer",
    backgroundColor: "#ffffff",
  },

  middleSection: {
    margin: "0px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flexGrow: 1,
    overflowY: "auto",
    minHeight: 0,
    paddingRight: "15px",
    boxSizing: "border-box",
    textAlign: "left",
  },

  privacyText: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "150%",
    color: "#344054",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  link: {
    color: "#4f87ff",
    textDecoration: "none",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  subTitle: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    color: "#101828",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  optionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  optionItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  optionLeft: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    cursor: "pointer",
    // The row is space-between, so without this the gap between the label and
    // the control belongs to neither and swallows a click aimed at the row.
    // minWidth lets a long heading wrap rather than push the control out.
    flexGrow: 1,
    minWidth: 0,
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  optionTextContainer: {
    display: "flex",
    flexDirection: "column",
    // Carries the product heading's click handler, so it has to reach the
    // control rather than stopping at the end of a short name like "Default".
    flexGrow: 1,
    minWidth: 0,
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  optionTitle: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    color: "#101828",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  optionDescription: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    color: "#475467",
    verticalAlign: "middle",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  checkboxLarge: {
    height: "20px",
    width: "20px",
    padding: "4px",
    borderRadius: "5px",
    border: "2px solid #d0d5dd",
    margin: 0,
    boxSizing: "border-box",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    cursor: "pointer",
    position: "relative",
    backgroundColor: "transparent",
  },

  dataElementsContainer: {
    display: "flex",
    flexDirection: "column",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    paddingLeft: "22px",
  },

  dataElementItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "space-between",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    minHeight: "24px",
  },

  // Applied only where the control is taller than a checkbox: a yes/no pair,
  // a dropdown or a switch. Unconditionally these leave the checkbox rows
  // loose.
  dataElementsContainerRoomy: {
    gap: "4px",
  },

  dataElementItemRoomy: {
    minHeight: "28px",
    padding: "2px 0",
  },

  dataElementText: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    color: "#344054",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  checkboxSmall: {
    height: "16px",
    width: "16px",
    padding: "4px",
    borderRadius: "5px",
    border: "2px solid #d0d5dd",
    margin: 0,
    boxSizing: "border-box",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    cursor: "pointer",
    position: "relative",
    backgroundColor: "transparent",
  },

  bottomSection: {
    display: "flex",
    justifyContent: "space-between",
    gap: "29px",
    paddingTop: "15px",
    borderTop: "none",
    backgroundColor: "#ffffff",
    margin: 0,
    boxSizing: "border-box",
  },

  /**
   * The main notice footer. Wide: one row with decline pushed left and the
   * accepts grouped right. Narrow: a full-width stack. Review mode keeps
   * `bottomSection` — it collapses to a single button.
   */
  actionButtonRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
    paddingTop: "15px",
    borderTop: "none",
    backgroundColor: "#ffffff",
    margin: 0,
    boxSizing: "border-box",
  },

  actionButtonStack: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    paddingTop: "15px",
    borderTop: "none",
    backgroundColor: "#ffffff",
    margin: 0,
    boxSizing: "border-box",
  },

  button: {
    width: "100%",
    borderRadius: "8px",
    padding: "9px 45px",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    cursor: "pointer",
    margin: 0,
    boxSizing: "border-box",
    textAlign: "center",
  },

  otpGateLocked: {
    pointerEvents: "none",
    opacity: 0.55,
  },

  otpGatePanel: {
    margin: "8px 0 4px",
    padding: "12px",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    background: "#f9fafb",
  },

  otpGateTitle: {
    margin: 0,
    fontSize: "13px",
    fontWeight: 600,
    color: "#111827",
  },

  otpGateDescription: {
    margin: "4px 0 10px",
    fontSize: "12px",
    lineHeight: 1.4,
    color: "#6b7280",
  },

  otpGateDigits: {
    display: "flex",
    gap: "8px",
    justifyContent: "space-between",
  },

  otpGateDigit: {
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    padding: "10px 0",
    fontSize: "18px",
    fontWeight: 600,
    textAlign: "center",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    background: "#ffffff",
  },

  otpGateError: {
    margin: "8px 0 0",
    fontSize: "12px",
    color: "#dc2626",
  },

  otpGateButton: {
    width: "100%",
    marginTop: "10px",
  },

  acceptButton: {
    backgroundColor: "#4f87ff",
    border: "none",
    color: "#ffffff",
  },

  /**
   * Accept Selected: outlined in the accent so it still reads as an accept,
   * subordinate to the filled Accept All.
   */
  acceptSecondaryButton: {
    backgroundColor: "#ffffff",
    border: "1px solid #4f87ff",
    color: "#4f87ff",
  },

  /**
   * Three buttons share the footer width, so the single-button horizontal
   * padding would clip long translated labels. Let them wrap instead.
   *
   * `width: auto` undoes `button`'s `width: 100%` — in the wide row each button
   * must size to its own label, or all three stretch equally and the
   * left/right split disappears.
   */
  rowButton: {
    width: "auto",
    padding: "9px 20px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },

  /** In the narrow stack every button spans the full width. */
  stackButton: {
    width: "100%",
    padding: "9px 20px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },

  /**
   * Pushes everything after decline to the right edge, which is the whole of
   * the wide layout: `[Decline] <-- gap --> [Accept Selected] [Accept All]`.
   */
  declineSpacer: {
    marginRight: "auto",
  },

  cancelButton: {
    border: "1px solid #d0d5dd",
    backgroundColor: "#ffffff",
    color: "#000000",
  },

  languageSelectorContainer: {
    position: "relative",
    // Shares `headerRow` with the title, which grows; without this a long
    // heading squeezes the language button instead of wrapping itself.
    flexShrink: 0,
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  languageDropdown: {
    position: "absolute",
    top: "100%",
    right: 0,
    backgroundColor: "#ffffff",
    border: "1px solid #d0d5dd",
    borderRadius: "4px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
    zIndex: 10,
    width: "max-content",
    maxHeight: "200px",
    overflowY: "auto",
    marginTop: "4px",
    padding: 0,
    boxSizing: "border-box",
    textAlign: "left",
  },

  languageItem: {
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "12px",
    color: "#344054",
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e5e7eb",
    margin: 0,
    boxSizing: "border-box",
    textAlign: "left",
  },

  selectedLanguageItem: {
    backgroundColor: "#f3f4f6",
    fontWeight: 600,
  },

  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    minHeight: "200px",
    margin: 0,
    boxSizing: "border-box",
  },

  loadingSpinner: {
    width: "40px",
    height: "40px",
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "1rem",
    boxSizing: "border-box",
  },

  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0 0 8px",
    padding: 0,
    boxSizing: "border-box",
  },

  sectionBody: {
    paddingLeft: "18px",
    margin: "0 0 14px",
    boxSizing: "border-box",
  },

  sectionTitle: {
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  chevronButton: {
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },

  confirmHint: {
    fontSize: "13px",
    lineHeight: "18px",
    color: "#6b6b6b",
    margin: 0,
    paddingTop: "12px",
    boxSizing: "border-box",
  },
} as const;

/**
 * The modal's style set, widened from the literal types above so an
 * appearance can supply its own values under the same keys.
 */
export type NoticeStyles = {
  [K in keyof typeof styles]: Record<string, string | number | undefined>;
};
